// extracted by mini-css-extract-plugin
export default {"container":"style_container__kOQWm","logoBox":"style_logoBox__ayOTO","text":"style_text__edBS0","logo":"style_logo__Rkd-6"};